import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 29 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M26.4 4.903 15.147.215a2.82 2.82 0 0 0-2.162 0L1.735 4.903A2.81 2.81 0 0 0 0 7.5c0 11.632 6.71 19.672 12.98 22.286.691.287 1.47.287 2.162 0 5.022-2.092 12.986-9.318 12.986-22.286a2.81 2.81 0 0 0-1.729-2.596ZM14.426 28.056a.96.96 0 0 1-.72 0C7.97 25.782 1.874 17.813 1.874 7.499c0-.38.229-.72.574-.867L13.7 1.944a.96.96 0 0 1 .72 0l11.251 4.688c.352.147.58.486.575.867.006 10.314-6.089 18.283-11.82 20.557m-.363-3.973V5.858L5.702 9.345c.592 7.038 4.518 12.599 8.362 14.738Zm-1.875-3.914c-2.133-2.339-3.856-5.732-4.46-9.64l4.46-1.858V20.17Z"
    }, null, -1)
  ])))
}
export default { render: render }